const CustomerAccountType = Object.freeze({
    PERSONAL: 'personal',
    BUSINESS: 'business'
});

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = CustomerAccountType;
}
